// extracted by mini-css-extract-plugin
export default {"line":"styles_line__hui+m","move":"styles_move__L9RQF","life":"styles_life__aBw-1","head":"styles_head__giYiQ","fate":"styles_fate__q0V6p","heart":"styles_heart__MiX+d"};